import type { ReactNode } from 'react';

interface SettingsCardProps {
  title: string;
  action: ReactNode;
  children: ReactNode;
  flushContent?: boolean;
}

export function SettingsCard({ title, action, children, flushContent = false }: SettingsCardProps) {
  return (
    <div className="flex flex-col gap-2.5 rounded-[6px] border border-[#DEE2E7] bg-white px-5 py-4">
      <div className="flex items-center justify-between">
        <h3 className="font-['Open_Sans',sans-serif] text-[14px] leading-5 font-semibold text-[#262D46]">{title}</h3>
        {action}
      </div>
      <div className="w-full border-t border-[#DEE2E7]" />
      <div className={flushContent ? '-mx-5 -mb-4' : ''}>{children}</div>
    </div>
  );
}
